import * as React from 'react'
import classNames from 'classnames'

import EmailSharingIcon from '../EmailSharingIcon'
import TwitterSharingIcon from '../TwitterSharingIcon'
import style from './style.scss'

type Props = {
  className?: string
  mailLabelText: string
  navLabelText: string
  title: string
  twitterLabelText: string
}

function SocialSharingInline(props: Props) {
  const url = window.location.href
  const {
    className,
    mailLabelText,
    navLabelText,
    title,
    twitterLabelText,
  } = props

  return (
    <nav
      aria-label={navLabelText}
      className={classNames(style.wrapper, className)}
    >
      <TwitterSharingIcon
        className={style.icon}
        iconLabelText={twitterLabelText}
        url={url}
        variant='dark'
      />
      <EmailSharingIcon
        className={style.icon}
        iconLabelText={mailLabelText}
        title={title}
        url={url}
        variant='dark'
      />
    </nav>
  )
}

export default SocialSharingInline
